// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"e3623f1d","242":"9bf6e8b0","257":"b385c2cb","402":"e70b1df0","438":"108a9540","499":"2791306c","627":"67defac0","643":"c8bbead0","830":"737b05ab","962":"71205622"}[chunkId] + ".css";
};